// extracted by mini-css-extract-plugin
export default {"tableContainer":"eSKZi","mobile":"Eq6aa","smallMobile":"zJsFJ","table":"TmQ0v","th":"PsWXR","td":"P2iOR","tr":"lap2v"};